/**
 * Message to inform a user when there are no projects viewable
 * in their profile.
 */
import {t} from "@lingui/core/macro";
import * as React from "react";

type Props = {
    // Is the person viewing this message the owner of the page?
    isSelf?: boolean;
};

class NoProjectsMessage extends React.Component<Props> {
    renderSelfView: () => React.ReactNode = () => {
        return (
            <div>
                <p>{t`You don't have any projects!`}</p>
                <p>
                    <strong>
                        {t`One way that you can create things is by learning to program.`}
                    </strong>
                    <br />
                    <a href="/computing/computer-programming">
                        {t`Learn how to program with: Computer Science curriculum`}
                    </a>
                </p>
                <p>
                    <strong>{t`Already know how to program?`}</strong>
                </p>
                <ul>
                    <li>
                        <a href="/computing/computer-programming/browse">
                            {t`Browse through existing programs`}
                        </a>
                    </li>
                    <li>
                        <a href="/computer-programming/new/pjs">
                            {t`Start a program from scratch`}
                        </a>
                    </li>
                </ul>
                <p>
                    <strong>{t`More resources:`}</strong>
                </p>
                <ul>
                    <li>
                        <a href="/computing/computer-programming/programming">
                            {t`Learn programming`}
                        </a>
                    </li>
                    <li>
                        <a href="/computing/computer-programming/browse">
                            {t`Browse programs`}
                        </a>
                    </li>
                    <li>
                        <a href="/computer-programming/new/pjs">
                            {t`Create a new program`}
                        </a>
                    </li>
                </ul>
            </div>
        );
    };

    renderOtherView: () => React.ReactNode = () => {
        return (
            <div>
                <p>{t`They don't have any projects!`}</p>
                <p>
                    {t`Encourage them to learn how to program with:`}{" "}
                    <a href="/computer-programming">
                        {t`Computer Science curriculum`}
                    </a>
                </p>
            </div>
        );
    };

    render(): React.ReactNode {
        if (this.props.isSelf) {
            return this.renderSelfView();
        }

        return this.renderOtherView();
    }
}

export default NoProjectsMessage;
